import React, { useEffect } from 'react';
import Clients from '../components/Clients';
import Footer from '../components/Footer';
import Benefits from '../components/Benefits';
import Contact from '../components/Contact';
import Location from '../components/Location';

const Portofolio = () => {
  useEffect(() => {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
  }, []);

    return (
        <>
            <Contact />
            <Location />
            <Clients />
            <Benefits />
            <Footer />
        </>

    )
}

export default Portofolio;

